import styled from '@emotion/styled';
import { Dialog } from '@mui/material';

import { Button } from 'components/buttons';
import IconChevron from 'components/icons/chevron';
import { InputRoot } from 'components/inputs/input/styles';
import { SelectableItem } from 'components/inputs/select/styles';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    maxWidth: 461,
  },
}));

export const CloseButton = styled(Button)(() => ({
  padding: 4,
  minWidth: 'unset',
}));

export const ModalContent = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 421,
  gap: 20,
  paddingBottom: 20,
}));

export const ModalSection = styled.div(() => ({
  minWidth: 421,
  padding: '0px 10px',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,

  // @ts-ignore
  [InputRoot]: {
    maxWidth: 290,
  },
}));

export const Label = styled.span(({ theme }) => ({
  display: 'flex',
  fontSize: 13,
  fontWeight: 400,
  fontFamily: theme.fonts.primary,
  color: theme.colors.text.primary,
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const Value = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  fontSize: 13,
});

export const CurrencyAdornment = styled.span(({ theme }) => ({
  color: theme.colors.inactive,
  fontWeight: 500,
  fontSize: 13,
  marginRight: 8,
  lineHeight: 1.4,
}));

export const ItemButton = styled(Button)(({ theme }) => ({
  padding: '10px 9.5px',
  justifyContent: 'flex-start',
  div: {
    fontWeight: 400,
  },
  path: {
    fill: `${theme.colors.white} !important`,
  },
}));

export const OutstandingValue = styled(Value)(({ theme }) => ({
  fontFamily: theme.fonts.secondary,
  fontSize: 14,
}));

export const ExpandSectionIcon = styled(IconChevron)<{ isExpanded: boolean }>(({ theme, isExpanded }) => ({
  height: 20,
  width: 20,
  transform: isExpanded ? 'rotate(0deg)' : 'rotate(180deg)',
  transition: 'transform 0.2s ease-in-out',
  marginLeft: 'auto',
  path: {
    fill: theme.colors.primary,
  },
}));

export const ExpandSectionHandle = styled(Button)((_) => ({
  width: '100%',
  padding: '4px 10px',
  span: {
    display: 'flex',
    fontWeight: 400,
    width: '100%',
  },
}));

export const SelectedSelectableItem = styled(SelectableItem)(({ theme }) => ({
  background: 'none',
  color: theme.colors.text.primary,
  '&:hover': {
    background: 'none',
  },
}));

export const DurationControls = styled.div(({ theme }) => ({
  display: 'flex',
  gap: 8,
  alignItems: 'center',
  width: '100%',
  maxWidth: 290,
  '& > button': {
    backgroundColor: theme.colors.container.primary,
    maxHeight: 34,
  },
}));
